import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './Photoslider.css';
import { getImageUrl } from '../../utils/imageUtils';

const Photoslider = () => {
  const [sliderImages, setSliderImages] = useState([]);
  const baseURL = window.APP_CONFIG?.API_URL || "https://backendweb.properteck.lk";

  useEffect(() => {
    const fetchSliderImages = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/slider/allphotos`);
        const photos = response.data?.photos || [];
        const formattedImages = photos.map(photo => ({
          _id: photo._id,
          url: getImageUrl(photo.imageUrl),
        }));
        setSliderImages(formattedImages);
      } catch (error) {
        console.error('Failed to fetch slider images:', error);
      }
    };

    fetchSliderImages();
  }, []);

  return (
    <div id="photoCarousel" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-indicators">
        {sliderImages.map((_, index) => (
          <button
            key={index}
            type="button"
            data-bs-target="#photoCarousel"
            data-bs-slide-to={index}
            className={index === 0 ? 'active' : ''}
            aria-current={index === 0 ? 'true' : undefined}
            aria-label={`Slide ${index + 1}`}
          ></button>
        ))}
      </div>

      <div className="carousel-inner">
        {sliderImages.map((image, index) => (
          <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={image._id}>
            <img
              src={image.url}
              className="d-block w-100"
              alt={`Slide ${index + 1}`}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = getImageUrl(null);
              }}
            />
          </div>
        ))}
      </div>

      <button className="carousel-control-prev" type="button" data-bs-target="#photoCarousel" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>

      <button className="carousel-control-next" type="button" data-bs-target="#photoCarousel" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Photoslider;
